import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const VaricoseUlcerPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Varicose Ulcer</h1>
        <section className="mb-8">
          <p>Varicose ulcers are chronic wounds that develop on the legs due to poor blood circulation, often associated with varicose veins. Our natural therapies focus on promoting wound healing, improving circulation, and preventing recurrence through gentle, effective herbal remedies and lifestyle modifications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Chronic venous insufficiency</li>
            <li>Untreated varicose veins</li>
            <li>Obesity</li>
            <li>Prolonged standing</li>
            <li>Injury to the leg</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Open, non-healing wound on the leg</li>
            <li>Pain and swelling</li>
            <li>Discoloration of the skin</li>
            <li>Itching and irritation</li>
            <li>Foul-smelling discharge (in severe cases)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use wound-healing herbs, circulation-boosting remedies, and lifestyle modifications to naturally treat varicose ulcers. Our approach focuses on promoting healing, reducing inflammation, and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Faster wound healing</li>
            <li>Improved circulation</li>
            <li>No harsh side effects</li>
            <li>Reduced risk of recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Keep the affected leg elevated</li>
            <li>Wear compression stockings</li>
            <li>Maintain good hygiene</li>
            <li>Avoid standing for long periods</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take for a varicose ulcer to heal?</strong>
            <p>A: Healing time varies, but many patients see improvement within 4-8 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for elderly patients?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all age groups, including seniors.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by improving circulation and promoting healing.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from varicose ulcers—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default VaricoseUlcerPage; 